module.exports = __webpack_public_path__ + "img/FAQ_Lady.8ccda65f.png";